export default function (element, data) {   
    element.addEventListener("click", () => window.scrollTo({ top: 0, behavior: 'smooth' }));

    window.addEventListener('scroll', () => {
        const scrollPos = window.scrollY;
        if (scrollPos > 200) {
            element.classList.add("visible");
        } else {
            element.classList.remove("visible");
        }
    }, {
        passive: true
    });
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary